import { useState, useEffect } from "react";
import { ITenantInfo } from "../interface/ITenant";


export function useSetDeadline({ client_info }: { client_info: ITenantInfo }) {
    const [deadline, setDeadline] = useState<string>("");

    useEffect(() => {
        if (client_info?.deadline) {
            const deadlineArr = client_info.deadline.split(":");
            setDeadline(deadlineArr[0] + ":" + deadlineArr[1]);
        }
    }, [client_info.deadline]);

    return deadline;
}

